module.exports = __webpack_public_path__ + "10b3ca9ff97bbe2eb0659e27d7f630d7.MP3";